export default function () {
    if ((navigator.userAgent.match(/iPhone/)) || (navigator.userAgent.match(/iPod/))) {
        $('body').addClass('iphone-device');
    }

    if (navigator.userAgent.match(/Android/)) {
        $('body').addClass('android-device');
    }
}
